//port of chatmeter/dashboard-play/ui/app/modules/reviews/ReviewService.js
import client from '../session/apiClient';


const api = {
  getNetPromoterScore: (params) => {
    return client
      .get(
        '/v5/netPromoterScore',
        {
          params,
        }
      )
      .then(response => response.data)
  },
  search: (params) => {
    const newParams = { ...params,  format: 'original'};
    return client.get('/v5/reviews', { params: newParams }).then(resp => resp.data);
  },
  snapshotSummary: (groupId) => {
    return client.get('/dashboard/reviewSummary/group/' + groupId)
      .then(resp => resp.data)
      .catch(ex => {
        throw new Error('Error occurred while summary!');
      })
  },
  averageReviewByState: (groupId) => {
    return client.get('/dashboard/stateSummary/group/' + groupId).then(resp => resp.data)
  },
  averageReviewByLocation: (groupId) => {
    return client
      .get('/dashboard/stateSummary/group/' + groupId)
      .then(resp =>  resp.data);
  },
  generateReviewReport: (params) => {
    return client
      .get('/v5/reviews/report', { params})
      .then(resp => resp.data)
      .catch(ex => { throw new Error('Error occurred while summary!'); });
  },
  //TODO - exportReviews, exportComparisonData, generateComparisonReport, locationsComparisonReport, locationComparisonReport, markReviewNotMine, addReviewTag, removeReviewTag, reaggregate
  submitReviewResponse: (reviewId, detail, isPublic) => {
    return api.submitReviewResponses([{reviewId, detail, isPublic}])
      .then(results => {
        if (results["errors"].length > 0) {
          throw results["errors"][0]
        }

        return results["succeeded"][0]
      })
  },
  submitReviewResponses: (instructions) => {
    return client.post(`/v5/reviews/responses`, {instructions})
      .then(response => response.data)
  },
  updateReviewResponse: (reviewId, responseId, details, shouldSubmit) => {
    return client.post(`/v5/reviews/${reviewId}/responses/${responseId}`, {
      detail: details,
      submit: shouldSubmit,
      reviewId: reviewId
    }).then(response => response.data)
  },

  removeResponse: (reviewId, responseId) => {
    return client.delete(`/v5/reviews/${encodeURIComponent(reviewId)}/responses/${encodeURIComponent(responseId)}`)
  },
  addNote: (reviewId, responseId, note) => {
    return client.post(`/v5/reviews/${reviewId}/responses/${responseId}/notes`, { note }).then(response => response.data);
  }
};

export default api;